import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { TreeViewComponent } from "@syncfusion/ej2-react-navigations";
import { DASHBOARD_WIDGETS } from "./DashboardWidgets";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import "./styles/Settings.css";

function AddDashboardPanel(props) {
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const hierarchicalData = useRef(DASHBOARD_WIDGETS);
  const treeViewRef = useRef();
  const fields = {
    dataSource: filterWidgets(
      hierarchicalData.current,
      projectObject.oada_bill_type__c,
    ),
    id: "id",
    text: "text",
    child: "subChild",
  };

  const addWidget = (event) => {
    //console.log("in AddDashboardPanel: " + event.currentTarget.id);
    props.addPanel(event.currentTarget.id);
  };

  function nodeExpand(args) {
    if (args.node.classList.contains("e-level-1") && args.isInteracted) {
      treeViewRef.current.collapseAll();
      treeViewRef.current.expandAll([args.node]);
      treeViewRef.current.expandOn = "None";
    }
  }

  function nodeSelect(args) {
    if (args.node.classList.contains("e-level-1")) {
      treeViewRef.current.collapseAll();
      treeViewRef.current.expandAll([args.node]);
      treeViewRef.current.expandOn = "None";
    }
  }

  function listNodeTemplate(data) {
    const billType = projectObject.oada_bill_type__c;
    let divClassName =
      data.id.length == 2 && data.subChild
        ? "settingsDashSetupParent"
        : data.id.length == 5 && data.subChild
          ? "settingsDashSetupSubParent"
          : "settingsDashSetupChild";

    let alreadySelected = false;
    let hiddenOption = false;
    if (data.widgetId) {
      if (data.appliesTo.indexOf(billType) == -1) {
        hiddenOption = true;
      }
      const dashboardConfig = JSON.parse(
        sessionStorage.getItem("dashboardConfig"),
      );
      const widgetIndex = dashboardConfig.findIndex(
        (elem) => elem.id == "widget_" + data.widgetId,
      );
      if (widgetIndex >= 0) {
        alreadySelected = true;
      }
    }

    return hiddenOption ? null : (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "275px",
          overflow: "hidden",
        }}
      >
        <div className={divClassName}>{data.text}</div>
        {divClassName == "settingsDashSetupChild" ? (
          alreadySelected ? (
            <CheckIcon id={data.widgetId} />
          ) : (
            <AddIcon
              //id={"add" + data.text + "|" + data.widgetId}
              id={data.widgetId}
              onClick={addWidget}
            />
          )
        ) : null}
      </Box>
    );
  }

  function filterWidgets(widgets, billType) {
    function deepFilter(items) {
      return items
        .map((item) => {
          const applies = item.appliesTo && item.appliesTo.includes(billType);

          // Recursively filter children
          let newItem = { ...item };
          if (item.subChild) {
            newItem.subChild = deepFilter(item.subChild);
          }

          // Keep item if it applies OR has valid children
          if (applies || (newItem.subChild && newItem.subChild.length > 0)) {
            return newItem;
          }

          // Otherwise exclude
          return null;
        })
        .filter(Boolean);
    }

    return deepFilter(widgets);
  }

  return (
    <Box
      width="400px"
      height="600px"
      sx={{
        border: "solid 5px",
        backgroundColor: "silver",
        borderRadius: "20px",
        borderColor: "#643f69",
        paddingTop: "20px",
      }}
    >
      <div className="control-pane">
        <div className="control-section">
          <div className="control_wrapper">
            <TreeViewComponent
              cssClass="accordiontree"
              fields={fields}
              nodeTemplate={listNodeTemplate}
              ref={(tvc) => (treeViewRef.current = tvc)}
              //nodeSelected={nodeSelect.bind(this)}
              nodeExpanding={nodeExpand.bind(this)}
              //expandedNodes={expNodes.current}
            />
          </div>
        </div>
      </div>
    </Box>
  );
}

export default AddDashboardPanel;

AddDashboardPanel.propTypes = {
  addPanel: PropTypes.func,
};
